var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _mask, _path, _path2, _mask2, _path3, _path4, _rect7, _rect8, _rect9, _rect10, _rect11, _path5, _path6, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle, _path7, _path8, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkThemeThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 207,
    viewBox: "0 0 342 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 341,
    height: 206,
    rx: 8.5,
    fill: "#182027",
    stroke: "#CFD8DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 141,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#66ADFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 141,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#CFD8DD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 160,
    width: 226,
    height: 8,
    rx: 2,
    fill: "#CFD8DD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 172,
    width: 187,
    height: 8,
    rx: 2,
    fill: "#CFD8DD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 141,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#CFD8DD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_1423_29570",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1H333C337.418 1 341 4.58172 341 9V29H1V9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1H333C337.418 1 341 4.58172 341 9V29H1V9Z",
    fill: "#182027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H341H1ZM341 30H1V28H341V30ZM1 29V1V29ZM341 1V29V1Z",
    fill: "#526069",
    mask: "url(#path-7-inside-1_1423_29570)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_1423_29570",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 29L30 206L9 206C4.58172 206 1 202.418 1 198L1.00001 29L30 29Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29L30 206L9 206C4.58172 206 1 202.418 1 198L1.00001 29L30 29Z",
    fill: "#182027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29L31 206L29 206L29 29L31 29ZM1 206L1.00001 29L1 206ZM1.00001 29L30 29L1.00001 29ZM30 206L1 206L30 206Z",
    fill: "#526069",
    mask: "url(#path-9-inside-2_1423_29570)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 8,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#8A97A0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 47,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#CFD8DD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 71,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#66ADFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 95,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#CFD8DD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 119,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#CFD8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 11.5617V12.3881H42.8574V11.7637L42.5911 12.3881H42.4771L42.2016 11.7637V12.3881H42.0683V11.5617H42.2491L42.5246 12.2137L42.8195 11.5617H43ZM41.2698 11.5617H41.8877V11.6811H41.6594V12.3881H41.5074V11.6811H41.2698V11.5617ZM41.5074 14.9314V17.5299H40.3285V15.0601C40.3285 14.3805 39.9674 13.9397 39.2733 13.9397C38.5793 13.9397 38.1611 14.3989 38.1611 15.161V17.5299H36.9822V11.5617H38.1611V13.5175C38.4556 13.1778 38.9216 12.9942 39.5585 12.9942C40.6518 12.9942 41.5074 13.7561 41.5074 14.9314ZM35.9555 16.5566H36.4213V17.5299H35.8033C34.6815 17.5299 34.1967 17.0158 34.1967 15.9598V14.0225H33.6454V13.0584H34.1967V11.8371H35.3755V13.0584H36.4117V14.0225H35.3755V15.969C35.3755 16.3639 35.4992 16.5566 35.9555 16.5566ZM31.896 15.2988C31.896 14.5275 31.4206 13.9949 30.6696 13.9949C29.9188 13.9949 29.4528 14.4999 29.4528 15.2988C29.4528 16.0425 29.8712 16.5842 30.6696 16.5842C31.3923 16.5842 31.896 16.0792 31.896 15.2988ZM31.896 13.0584H33.075V17.5299H31.896V17.025C31.5824 17.3831 31.0879 17.5851 30.3941 17.5851C29.139 17.5851 28.2551 16.6301 28.2551 15.2988C28.2551 13.9766 29.1201 13.0032 30.3941 13.0032C31.0689 13.0032 31.5824 13.2328 31.896 13.6184V13.0584ZM26.734 13.7471C26.734 13.1226 26.363 12.7554 25.6881 12.7554H24.7469V14.7846H25.6881C26.363 14.7846 26.734 14.4174 26.734 13.7471ZM27.9317 13.7471C27.9317 14.9683 27.095 15.6936 25.8116 15.6936H24.7469V17.5299H23.568V11.8371H25.8116C27.1142 11.8371 27.9317 12.5717 27.9317 13.7471ZM18.8431 17.5299H20.022V13.0584H18.8431V17.5299ZM20.1551 11.8371C20.1551 12.2411 19.8508 12.5166 19.4326 12.5166C19.0144 12.5166 18.71 12.2411 18.71 11.8371C18.71 11.424 19.0144 11.1394 19.4326 11.1394C19.8508 11.1394 20.1551 11.424 20.1551 11.8371ZM16.7326 11.8371H17.9115V15.1702C17.9115 16.676 17.0273 17.5851 15.5348 17.5851C14.0707 17.5851 13.2055 16.6943 13.2055 15.1702V11.8371H14.3844V15.1702C14.3844 16.0058 14.7456 16.5107 15.5633 16.5107C16.3524 16.5107 16.7326 16.0333 16.7326 15.1702V11.8371ZM12.1789 18.8613H21.2104V10.1385H12.1789V18.8613ZM11 20H22.3892V9H11V20Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283 29H341V198C341 202.418 337.418 206 333 206H283V29Z",
    fill: "#273139"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 47.5,
    width: 225,
    height: 78,
    rx: 3.5,
    fill: "#182027",
    stroke: "#526069"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 60,
    width: 93,
    height: 8,
    rx: 4,
    fill: "#CFD8DD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 59,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#44CFFC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 78,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#CFD8DD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 77,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FFCA55"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 96,
    width: 77,
    height: 8,
    rx: 4,
    fill: "#CFD8DD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 95,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#74C94B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 87,
    r: 29,
    fill: "#74C94B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93 57.5H92.5V58V87V87.5H93H122H122.532L122.499 86.9688C121.935 77.9424 118.957 71.9001 115.578 67.847C112.204 63.8001 108.452 61.7648 106.393 60.7153C102.245 58.6018 97.6554 57.5 93 57.5Z",
    fill: "#FFCA55",
    stroke: "#182027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 87L63.5 87.5L64 87.5L93 87.5L93.5 87.5L93.5 87L93.5 58L93.5 57.4678L92.9688 57.501C83.9424 58.0651 77.9001 61.043 73.847 64.4222C69.8001 67.7964 67.7648 71.5475 66.7153 73.6073C64.6018 77.7553 63.5 82.3446 63.5 87Z",
    fill: "#44CFFC",
    stroke: "#182027"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.9999,
    cy: 87,
    r: 15.6154,
    fill: "#182027"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkThemeThumbnail);
export default __webpack_public_path__ + "static/media/darkThemeThumbnail.52c77492f51c16947a2514ea09dda30a.svg";
export { ForwardRef as ReactComponent };